export const CountryList = [
  { country: 'Nigeria', countryCode: '1' },
  // { country: "Ghana", countryCode: "2" },
  // { country: "Senegal", countryCode: "3" },
];

export const StateList = [
  { state: 'Abia', stateCode: '1' },
  { state: 'Adamawa', stateCode: '2' },
  { state: 'Akwa Ibom', stateCode: '3' },
  { state: 'Anambra', stateCode: '4' },
  { state: 'Bauchi', stateCode: '5' },
  { state: 'Bayelsa', stateCode: '6' },
  { state: 'Benue', stateCode: '7' },
  { state: 'Borno', stateCode: '8' },
  { state: 'Cross River', stateCode: '9' },
  { state: 'Delta', stateCode: '10' },
  { state: 'Ebonyi', stateCode: '11' },
  { state: 'Edo', stateCode: '12' },
  { state: 'Ekiti', stateCode: '13' },
  { state: 'Enugu', stateCode: '14' },
  { state: 'Gombe', stateCode: '15' },
  { state: 'Imo', stateCode: '16' },
  { state: 'Jigawa', stateCode: '17' },
  { state: 'Kaduna', stateCode: '18' },
  { state: 'Kano', stateCode: '19' },
  { state: 'Katsina', stateCode: '20' },
  { state: 'Kebbi', stateCode: '21' },
  { state: 'Kogi', stateCode: '22' },
  { state: 'Kwara', stateCode: '23' },
  { state: 'Lagos', stateCode: '24' },
  { state: 'Nasarawa', stateCode: '25' },
  { state: 'Niger', stateCode: '26' },
  { state: 'Ogun', stateCode: '27' },
  { state: 'Ondo', stateCode: '28' },
  { state: 'Osun', stateCode: '29' },
  { state: 'Oyo', stateCode: '30' },
  { state: 'Plateau', stateCode: '31' },
  { state: 'Rivers', stateCode: '32' },
  { state: 'Sokoto', stateCode: '33' },
  { state: 'Taraba', stateCode: '34' },
  { state: 'Yobe', stateCode: '35' },
  { state: 'Zamfara', stateCode: '36' },
  { state: 'Abuja', stateCode: '37' },
];

export const OccupationList = [
  'Medical Doctor',
  'Nurse',
  'Midwife',
  'Nurse and Midwife',
  'Pharmacist',
  'Medical laboratory scientist',
  'Occupational therapist',
  'Speech therapist',
  'Osteopathic medicine',
  'Prosthetics and orthotics',
  'Physiotherapist',
  'Chiropractor',
  'Health Technician',
  '(CHEW) Community Health Extension workers',
];

export const facilityTypes = [
  'Hospitals And Clinics',
  'Laboratory',
  'Pharmaceuticals',
  'Radiology And Imaging',
];

export const Experience = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
